import React from 'react';

const RadioButton = ({ name, value, checked, onChange, disabled, id }) => {
  return (
    <label className={`custom-radio ${disabled ? 'disabled' : ''}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        id={id}
      />
      <span className="radio-circle"></span>
    </label>
  );
};

export default RadioButton;
